export default __webpack_public_path__ + "static/media/traits.41005960.png";